<template>
  <main class="flex-1 relative overflow-y-auto focus:outline-none" tabindex="0">
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8">
      <div class="md:flex md:items-center md:justify-between">
        <div class="flex min-w-0">
          <svg-vue class="content-title-icon" icon="font-awesome.edit-regular"></svg-vue>

          <h1 class="content-title">
            {{ $t('Edit warehouse') }}
          </h1>
        </div>
        <div class="mt-4 flex md:mt-0 md:ml-4">
          <button @click="deleteWarehouseModal = true" class="btn btn-red rounded-none rounded-l-md" type="button">
            {{ $t('Delete') }}
          </button>
          <router-link class="btn btn-app rounded-none rounded-r-md" to="/admin/warehouses">
            {{ $t('Back') }}
          </router-link>
        </div>
      </div>
    </div>
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8">
      <div class="content-card-body">
        <loading :status="loading"></loading>
        <form @submit.prevent="updateWarehouse">
          <div class="md:grid md:grid-cols-3 md:gap-6 px-4 py-5 sm:p-6">
            <div class="md:col-span-1">
              <h3 class="form-description-head">
                {{ $t('Warehouse details') }}
              </h3>
              <p class="form-description-text">{{ $t('This information will be displayed publicly') }}.</p>
            </div>
            <div class="mt-5 md:mt-0 md:col-span-2">
              <div class="grid grid-cols-3 gap-6">
                <div class="col-span-3">
                  <label class="form-label" for="name">{{ $t('Name') }}</label>
                  <div class="pt-1">
                    <input :placeholder="$t('Name')" class="form-input" id="name" required v-model="warehouse.name" />
                  </div>
                </div>
                <div class="col-span-3">
                  <label class="form-label" for="max_volume">{{ $t('Max volume') }}</label>
                  <div class="pt-1">
                    <input :placeholder="$t('Max volume')" class="form-input" id="max_volume" required type="number" v-model="warehouse.max_volume" />
                  </div>
                </div>
                <div class="col-span-3">
                  <label class="form-label" for="location">{{ $t('Location') }}</label>
                  <div class="pt-1">
                    <input :placeholder="$t('Location')" class="form-input" id="location" required v-model="warehouse.location" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <span class="inline-flex">
              <router-link class="btn btn-app mr-4" to="/admin/warehouses">{{ $t('Cancel') }}</router-link>
              <button class="btn btn-green" type="submit">
                {{ $t('Update') }}
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
    <warehouse-delete-model :show="deleteWarehouseModal" @cancelled="deleteWarehouseModal = false" @confirmed="deleteWarehouse">
      <template #title>{{ $t('Delete warehouse') }}</template>
      {{ $t('Are you sure you want to delete the warehouse ?') }}
      {{ $t('All data will be permanently removed') }}.
    </warehouse-delete-model>
  </main>
</template>
<script>
import confirmationModel from '@/components/layout/admin/confirmation';
export default {
  name: 'edit',
  metaInfo() {
    return {
      title: this.$i18n.t('Edit warehouse'),
    };
  },
  components: {
    WarehouseDeleteModel: confirmationModel,
  },
  data() {
    return {
      loading: true,
      deleteWarehouseModal: false,
      warehouse: {
        name: null,
        location: null,
        max_volume: null,
      },
    };
  },
  mounted() {
    this.getWarehouse();
  },
  methods: {
    updateWarehouse() {
      this.loading = true;
      axios
        .put(route('warehouses.update', this.$route.params.id), this.warehouse)
        .then((response) => {
          this.loading = false;
          this.$notify({
            title: this.$i18n.t('Success').toString(),
            text: response.data.message.toString(),
            type: 'success',
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getWarehouse() {
      this.loading = true;
      axios
        .get(route('warehouses.show', this.$route.params.id))
        .then((response) => {
          this.warehouse = response.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    deleteWarehouse() {
      axios
        .delete(route('warehouses.destroy', this.$route.params.id))
        .then((response) => {
          this.$notify({
            title: this.$i18n.t('Success').toString(),
            text: response.data.message.toString(),
            type: 'success',
          });
          this.$router.push('/admin/warehouses');
        })
        .catch(() => {
          this.deleteWarehouseModal = false;
        });
    },
  },
};
</script>
